import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Callout, Typography } from 'seagull';
import { useLocaleKeys } from '~/i18n';
export const ZapierHeader = ()=>{
    const { t } = useLocaleKeys('integrations.availableApps.zapier');
    return /*#__PURE__*/ _jsx(Callout, {
        intent: "info",
        testId: "zapier-v2-disclaimer",
        children: t.v2Disclaimer()
    });
};
export const ZapierSteps = ()=>{
    const { t } = useLocaleKeys('integrations.availableApps.zapier');
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                children: t.v2Step2()
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: t.v2Step3()
            })
        ]
    });
};
